import React from 'react';

interface TextMessageProps {
  text: any,
}

const TextMessage: React.FC<TextMessageProps> = ({ text }) =>
  text
    .split(/\n/)
    .map((str: any, index: boolean) => (
      <p key={`alert-detail-text-${String(index)}`}>
        {str}
      </p>));

export default TextMessage;
